import offerFormIndex from '@/view/offerForm/index'
import offerFormResult from '@/view/offerForm/result'

const offerFormRouter = [
  {
    path: '/offerForm/index.html',
    name: 'offer-form-index',
    component: offerFormIndex,
    meta: {
      title: '设计报价器'
    }
  },
  {
    path: '/offerForm/result.html/:id/:budget/:stage',
    name: 'offer-form-result',
    component: offerFormResult,
    meta: {
      title: '报价结果'
    }
  }
]

export default offerFormRouter



// WEBPACK FOOTER //
// ./src/router/offerForm/offerForm.js